const settings = {
  marginOfError: 10
}

export default settings